"use client"
import type { AutoFormInputComponentProps } from "../types"
import { useTranslations } from "next-intl"
import { FormControl, FormItem, FormMessage } from "@/components/ui/form"
import { cn } from "@/lib/utils"
import { createDateFromString, extractUTCDateAsLocal } from "@/utils/date-utils"
import DateRangePicker from "../../date-range-picker"
import AutoFormLabel from "../common/label"
import AutoFormTooltip from "../common/tooltip"

export function AutoFormRangePicker({
  label,
  isRequired,
  field,
  fieldConfigItem,
  fieldProps,
}: AutoFormInputComponentProps) {
  const t = useTranslations("generic")

  // Convertir fechas de string a Date sin conversión de zona horaria
  const minDate: Date | undefined = fieldProps.min
    ? (typeof fieldProps.min === "string"
        ? (fieldProps.min.includes("T") ? extractUTCDateAsLocal(fieldProps.min) : createDateFromString(fieldProps.min)) || undefined
        : fieldProps.min as Date)
    : undefined
  const maxDate: Date | undefined = fieldProps.max
    ? (typeof fieldProps.max === "string"
        ? (fieldProps.max.includes("T") ? extractUTCDateAsLocal(fieldProps.max) : createDateFromString(fieldProps.max)) || undefined
        : fieldProps.max as Date)
    : undefined

  const shouldShowNoDateMessage = fieldProps.disableAllDatesWithoutRange && minDate === undefined && maxDate === undefined
  return (
    <FormItem className={cn(fieldConfigItem?.containerClassName)}>
      <AutoFormLabel
        isRequired={isRequired}
        label={fieldConfigItem?.label ?? label}
      />
      <FormControl>
        <DateRangePicker
          dateRange={field.value}
          setDateRange={field.onChange}
          {...fieldProps}
        />
      </FormControl>
      <AutoFormTooltip fieldConfigItem={fieldConfigItem} />

      {shouldShowNoDateMessage && (
        <FormMessage>{t("no_dates_available")}</FormMessage>
      )}
      {!shouldShowNoDateMessage && <FormMessage />}
    </FormItem>
  )
}
